import { isCropContextViewEnabled } from '../hooks/useCropContextView';
import { MasterUPCData } from '../types';
import { cropContextImageUrl } from './cropContextImage';
import { collectUpcCrops } from './masterLabelCrops';

export function collectMasterLabelUpcCropImageUrls(
  upc: MasterUPCData,
  priorityCropIds?: Iterable<string>
): string[] {
  const crops = collectUpcCrops(upc);
  const urls: string[] = [];
  const seenUrls = new Set<string>();

  const withContext = isCropContextViewEnabled();
  const addCropUrl = (crop: { imageUrl?: string }) => {
    // Preload exactly what CropThumbnail renders, or every thumbnail refetches.
    const url = withContext ? cropContextImageUrl(crop.imageUrl) : crop.imageUrl ?? '';
    if (!url || seenUrls.has(url)) return;
    seenUrls.add(url);
    urls.push(url);
  };

  const priorityIds = priorityCropIds ? [...priorityCropIds].filter(Boolean) : [];
  if (priorityIds.length > 0) {
    const cropsById = new Map(crops.map((crop) => [crop.id, crop]));
    priorityIds.forEach((cropId) => {
      const crop = cropsById.get(cropId);
      if (crop) addCropUrl(crop);
    });
  }

  crops.forEach(addCropUrl);
  return urls;
}

/** Every URL variant a column may have cached, for release when it closes. */
export function collectMasterLabelUpcCropImageUrlVariants(upc: MasterUPCData): string[] {
  const urls = new Set<string>();
  collectUpcCrops(upc).forEach((crop) => {
    if (!crop.imageUrl) return;
    urls.add(crop.imageUrl);
    urls.add(cropContextImageUrl(crop.imageUrl));
  });
  return [...urls];
}

export function collectMasterLabelCropImageUrls(upcs: MasterUPCData[]): string[] {
  return [...new Set(upcs.flatMap((upc) => collectMasterLabelUpcCropImageUrls(upc)))];
}
